// ABOUTME: Zod validation schemas and types for TechLog -> RAAS completed flight transformation.
import {
  ZRaasAircraftStatus,
  ZRaasFlightLogCreateRequest,
} from '../../../../activities/api/raas/raas.zod';
import { ZdateTime } from '../../../../types/common.zod';
import { ZTechlogAircraftWithType } from '../../../../types/techLog/aircraft.zod';
import { ZTechlogAirport } from '../../../../types/techLog/airport.zod';
import {
  ZTechlogFuelUplifts,
  ZTechlogFluidUplift,
} from '../../../../types/techLog/fuel.zod';
import { TechlogFlightStatus } from '../../../../types/techLog/sector';
import { ZTechLogSector } from '../../../../types/techLog/sector.zod';
import { ZTechLogTrip } from '../../../../types/techLog/trip.zod';
import { z } from 'zod';

export const ZTechlogToRaasFlightInput = z.object({
  techlog: z.object({
    // takeoffTime and landingTime are optional on generic TechLog reads,
    // but RAAS rejects flight logs when minutesInAir cannot be derived exactly.
    sector: ZTechLogSector.extend({
      status: z.literal(TechlogFlightStatus.COMPLETE),
      takeoffTime: ZdateTime,
      landingTime: ZdateTime,
    }),
    trip: ZTechLogTrip,
    aircraft: ZTechlogAircraftWithType,
    airportDeparture: ZTechlogAirport,
    airportArrival: ZTechlogAirport,
    fuelUplifts: z.array(ZTechlogFuelUplifts),
    fluidUplifts: z.array(ZTechlogFluidUplift),
  }),
  raas: z.object({
    aircraftStatus: ZRaasAircraftStatus.nullable(),
  }),
});

export const ZTechlogToRaasFlightOutput = ZRaasFlightLogCreateRequest;

export type TechlogToRaasFlightInput = z.infer<
  typeof ZTechlogToRaasFlightInput
>;
export type TechlogToRaasFlightOutput = z.infer<
  typeof ZTechlogToRaasFlightOutput
>;
